<template>
  <div class="section-category pay-section-category">
    <div class="section-pay mx-auto">
      <h2 class="ttl-pay text-center" v-translate>PAY</h2>
      <div class="pay-form">
        <div class="pay-types-list">
          <div
            v-if="
              payType.indexNumber >= amountPayType.indexNumber
              && ( payType.name != 'invoice' || isPayInvoice)"
            v-for="payType in payTypes"
            class="form-group row line pb-2" >
            <div
              class="ttl col-7 pay-type" >
              <span>{{ payType.name }}</span>
              <span v-if="payType.value && payType.value != 0">
                ({{ payType.value }}%)
              </span>
            </div>
            <div
              v-if="(payType.value && payType.value != 0)
                      || isSpecialPayType(payType.name)"
              class="col-5 txt-r pay-ttl" >
              <strong>{{ getPayDetail(payType).total | currency }}</strong>
            </div>
            <div
              v-else
              class="col-5 txt-r pay-ttl" >
              <input-pad
                :item="getPayDetail(payType)"
                :property="'total'"
                :maxLength="10"
                :usingDecimal="usingDecimal"
                :attributes="{'class': 'payment'}"/>
            </div>
          </div>
        </div>
        <div class="button-footer">
          <div
            v-if="isCustomerCreditOverLimit"
            class="customer-credit-warning text-left">
            <strong v-translate>Customer credit limit warning</strong>
            <div>
              <translate>Projected credit</translate>:
              {{ creditStatus.projectedRemainingCredit | currency }}
            </div>
            <div>
              <translate>Credit limit</translate>:
              {{ creditStatus.creditLimit | currency }}
            </div>
            <div>
              <translate>Over limit by</translate>:
              {{ creditStatus.overLimitAmount | currency }}
            </div>
          </div>
          <button type="button" class="btn btn-primary" @click="closeBill" v-translate>Close</button>
          <router-link :to="{name: 'order'}" class="btn btn-default" v-translate>Cancel</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';
// eslint-disable-next-line import/no-cycle
import CustomerService from '@/services/CustomerService';

export default {
  name: 'Pay',
  data() {
    return {
      specialPayTypes: ['subtotal', 'total', 'amount', 'change'],
      creditStatus: null,
      creditStatusRequestKey: 0,
    };
  },
  computed: {
    payTypes() {
      return this
              .getArray('payTypes')
              .sort((a, b) => a.indexNumber > b.indexNumber ? 1 : -1)
    },
    amountPayType() {
      return this.getObject('amount', 'payTypes', 'name');
    },
    currentInputPad() { return this.getMap('currentInputPad', true) },
    bill() { return this.getMap('bill', true) },
    billCustomer() { return this.bill.customer; },
    ...mapGetters(['totalAmount', 'getPayDetail', 'isPayInvoice']),
    usingDecimal() { return this.$store.state.auth.currency.decimalType },
    location() {
      return this.$store.state.auth.user.location;
    },
    customerCreditPayTypeIds() {
      return this.payTypes
        .filter(payType => !!payType.isCustomerCredit)
        .map(payType => String(payType.id));
    },
    pendingCustomerCreditAmount() {
      if (!this.bill.payDetails) return 0;
      return this.bill.payDetails.reduce((total, payDetail) => {
        if (this.customerCreditPayTypeIds.indexOf(String(payDetail.payType)) === -1) return total;
        const amount = parseFloat(payDetail.total);
        if (!amount || amount <= 0) return total;
        return total + amount;
      }, 0);
    },
    isCustomerCreditOverLimit() {
      return !!(this.creditStatus && this.creditStatus.isOverLimit);
    },
    customerCreditLimitMode() {
      return (this.location && this.location.customerCreditLimitMode) || 'warn';
    },
    canCloseWithCustomerCredit() {
      return this.customerCreditLimitMode !== 'block' || !this.isCustomerCreditOverLimit;
    },
  },
  methods: {
    isSpecialPayType(payType) {
      return this.specialPayTypes.indexOf(payType) != -1;
    },
    async refreshCreditStatus() {
      const requestKey = this.creditStatusRequestKey + 1;
      this.creditStatusRequestKey = requestKey;

      if (!this.pendingCustomerCreditAmount
        || !this.bill.customer
        || !this.location
        || !this.location.id
      ) {
        this.creditStatus = null;
        return;
      }

      const creditStatus = await CustomerService.getCreditStatus(
        this.bill.customer,
        {
          location: this.location.id,
          creditAmount: this.pendingCustomerCreditAmount,
        },
      );

      if (requestKey !== this.creditStatusRequestKey) return;
      this.creditStatus = creditStatus || null;
    },
    async closeBill() {
      if (!this.canCloseWithCustomerCredit) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Customer credit limit exceeded'));
        return;
      }
      const changePayType = this.getObject('change', 'payTypes', 'name');
      const change = this.getPayDetail(changePayType);
      if(change && change.total >= 0) {
        this
          .$store
          .dispatch(
            'closeBill',
            {
              id: this.bill.id,
              payDetails: this.bill.payDetails
            }
          );
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Amount not paid in full'));
      }
    },
  },
  mounted() {
    if(!this.bill.id) this.$router.replace({ name: 'order' });
    this.refreshCreditStatus();
  },
  watch: {
    pendingCustomerCreditAmount() {
      this.refreshCreditStatus();
    },
    billCustomer() {
      this.refreshCreditStatus();
    },
    currentInputPad(value) {
      if(value.item) {
        const invoicePayType = this.getObject('invoice', 'payTypes', 'name');
        if(value.item.payType == invoicePayType.id) {
          const otherPayTypes = this
                                  .getArray('payTypes')
                                  .filter(payType =>
                                    payType.indexNumber > this.AMOUNT_PAYTYPE
                                    && payType.indexNumber < this.CHANGE_PAYTYPE
                                    && payType.indexNumber != this.INVOICE_PAYTYPE
                                  );
          otherPayTypes.forEach(payType => {
            const payDetail = this.getPayDetail(payType);
            payDetail.total = 0;
          });
          const amountPayType = this.getObject('amount', 'payTypes', 'name');
          const amount = this.getPayDetail(amountPayType);
          value.item.total = Math.abs(amount.total);
        } else {
          const invoice = this.getPayDetail(invoicePayType);
          invoice.total = 0;
        }
      }
    }
  }
};
</script>
<style scoped>
.pay-section-category {
  align-items: stretch;
  display: flex;
  justify-content: center;
}

.section-pay {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  min-height: 0;
}

.ttl-pay {
  flex: 0 0 auto;
}

.pay-form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  margin: 0 10px;
  min-height: 0;
  overflow: hidden;
  width: calc(100% - 20px);
}

.pay-types-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 6px;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
}

.pay-types-list::-webkit-scrollbar {
  width: 8px;
}

.pay-types-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.pay-types-list::-webkit-scrollbar-thumb {
  background: #b3b3b3;
  border-radius: 8px;
}

.pay-types-list::-webkit-scrollbar-thumb:hover {
  background: #8a8a8a;
}

.button-footer {
  flex: 0 0 auto;
  width: 100%;
}

.customer-credit-warning {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 2px;
  color: #856404;
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 10px;
  padding: 8px 10px;
  width: 100%;
}
</style>
